/**
 * 日志工具模块
 * 提供带样式的控制台日志输出功能
 * 属于核心基础设施层，被其他模块依赖
 * 
 * @module core/logger
 * @author wei<innereyecw@gmail.com>
 * @version 5.0.0
 */
(function (global) {
  "use strict";
  
  // 确保 watashi.core 存在
  if (!global.watashi) {
    global.watashi = {};
  }
  if (!global.watashi.core) {
    global.watashi.core = {};
  }
  
  const core = global.watashi.core;

  // ==================== 日志样式配置 ====================
  const LOG_STYLES = {
    info: 'background:rgba(0,0,0,.7);font-size:12px;color:white;',
    warn: 'background:rgba(0,0,0,.7);font-size:12px;color:red;',
    success: 'background:rgba(0,0,0,.7);font-size:12px;color:#4CAF50;',
    debug: 'background:rgba(0,0,0,.7);font-size:12px;color:#2196F3;'
  };

  /**
   * 日志工具对象
   * @namespace logger
   */
  core.logger = {
    /**
     * 输出日志信息
     * @param {string} msg - 日志消息
     * @param {string} [level='info'] - 日志级别：'info' | 'warn' | 'success' | 'debug'
     * 
     * @example
     * watashi.core.logger.log('普通信息');
     * watashi.core.logger.log('警告信息', 'warn');
     * watashi.core.logger.log('成功信息', 'success');
     */
    log: function (msg, level = 'info') {
      const style = LOG_STYLES[level.toLowerCase()] || LOG_STYLES.info;
      console.log(`%c${msg}`, style);
    },
    
    /**
     * 输出错误信息
     * @param {string} msg - 错误消息
     * @param {Error} [error] - 可选的错误对象
     * 
     * @example
     * watashi.core.logger.error('发生错误');
     * watashi.core.logger.error('详细错误', errorObject);
     */
    error: function (msg, error) {
      console.error(`%c${msg}`, LOG_STYLES.warn);
      if (error) {
        console.error(error);
      }
    },
    
    /**
     * 输出警告信息
     * @param {string} msg - 警告消息
     * 
     * @example
     * watashi.core.logger.warn('这是一个警告');
     */
    warn: function (msg) {
      console.warn(`%c${msg}`, LOG_STYLES.warn);
    },
    
    /**
     * 输出调试信息
     * @param {string} msg - 调试消息
     * @param {*} [data] - 可选的附加数据
     * 
     * @example
     * watashi.core.logger.debug('调试信息', {key: 'value'});
     */
    debug: function (msg, data) {
      console.log(`%c${msg}`, LOG_STYLES.debug);
      if (data !== undefined) {
        console.log(data);
      }
    }
  };

})(typeof window !== "undefined" ? window : this);
